import { render, staticRenderFns } from "./topic.vue?vue&type=template&id=d7e36748&scoped=true&"
import script from "./topic.vue?vue&type=script&lang=js&"
export * from "./topic.vue?vue&type=script&lang=js&"
import style0 from "./topic.vue?vue&type=style&index=0&id=d7e36748&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7e36748",
  null
  
)

export default component.exports